const riot = require('riot');
import '../components/tagging.tag'
riot.tag2('page-tagging', '<tagging></tagging>', '', '', function(opts) {
});
